export enum HourOfOperationType {
  CURBSIDE = 'curbsideHours',
  DELIVERY = 'deliveryHours',
  DINING_ROOM = 'diningRoomHours',
  DRIVE_THRU = 'driveThruHours',
}
